export async function uploadUtil(file) {
  //上传前处理


  return await beforeUpload(file)

  function beforeUpload(file) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 2;

    if (!isJPG) {
      this.$message.error('上传图片只能是 JPG/PNG 格式!');
    }
    if (!isLt2M) {
      this.$message.error('上传图片大小不能超过 2MB!');
    }

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const img = new Image();
        img.src = reader.result;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          const originWidth = img.width;
          const originHeight = img.height;
          const targetWidth = originWidth;
          const targetHeight = originHeight;

          canvas.width = targetWidth;
          canvas.height = targetHeight;
          ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

          // 压缩图片
          const dataURL = canvas.toDataURL('image/jpeg', 0.8); // 0.8 是图片质量，范围从 0 到 1
          const compressedFile = dataURLtoFile(dataURL, file.name);

          resolve(compressedFile);
        };
      };
    });
  }


  function dataURLtoFile(dataURL, fileName) {
    const arr = dataURL.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, {type: mime});
  }
}



// WEBPACK FOOTER //
// ./src/utils/uploadCommon.js